module.exports = __webpack_public_path__ + "img/screen2.24a1792d.jpg";